export enum SchemaField {
  InputText = 'InputText',
  InputPassword = 'InputPassword',
  InputCurrency = 'InputCurrency',
  InputCheckbox = 'InputCheckbox',
  InputSwitch = 'InputSwitch',
  InputSelect = 'InputSelect',
  InputFile = 'InputFile',
  InputDateTime = 'InputDateTime',
  InputDate = 'InputDate',
  InputMask = 'InputMask',
  InputHidden = 'InputHidden',
  InputAutoComplete = 'InputAutoComplete',
  InputPhoneNumber = 'InputPhoneNumber',
  InputMultipleSelect = 'InputMultipleSelect',
  InputMultipleAutoComplete = 'InputMultipleAutoComplete',
  InputTabs = 'InputTabs',
  InputTextEditor = 'InputTextEditor',
  InputTimePicker = 'InputTimePicker'
}

export enum SchemaInputType {
  file = 'file',
  checkbox = 'checkbox',
  text = 'text',
  url = 'url',
  email = 'email',
  texteditor = 'texteditor',
  textarea = 'textarea',
  number = 'number',
  password = 'password',
}
